import { Component, OnInit } from '@angular/core';
import { wrapperupdateUserUI, wrapperGetLogoUrlInApp } from '../app/javascript.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'scanwritr';

  ngOnInit(): void {
    wrapperupdateUserUI();
    wrapperGetLogoUrlInApp();
  }
}
